import React from 'react';
import AdminLayout from '../components/AdminLayout';
import { Icon } from '../utils/icons';

const hexToRgba = (hex, a) => { const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16); return `rgba(${r},${g},${b},${a})`; };

function KPI({ label, value, sub, iconName, color }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '14px', padding: '18px 20px', display: 'flex', alignItems: 'center', gap: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
      <div style={{ width: '46px', height: '46px', borderRadius: '12px', background: hexToRgba(color, 0.12), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon name={iconName} size={22} color={color} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '4px' }}>{label}</div>
        <div style={{ fontSize: '26px', fontWeight: '900', color: '#111827', lineHeight: 1 }}>{value}</div>
        {sub && <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '3px' }}>{sub}</div>}
      </div>
    </div>
  );
}

export default function DashLoanPerformance() {
  return (
    <AdminLayout>
      <div style={{ padding: '28px 32px', maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px' }}>
          <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>Loan Performance</h1>
          <p style={{ fontSize: '13px', color: '#6b7280' }}>Portfolio health metrics and early warning indicators</p>
        </div>

        {/* ── Delinquency ── */}
        <div style={{ background: '#edf1fb', border: '1px solid #c5d3f5', borderRadius: '16px', padding: '20px', marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', fontWeight: '700', color: '#3a6ad9', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>Delinquency</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
            <KPI label="Delinquency Rate (30+)" value="—" sub="% of loans past due by bucket" iconName="warning" color="#f59e0b" />
            <KPI label="Delinquency Rate (60+)" value="—" sub="% of loans 60+ days past due" iconName="warning" color="#f59e0b" />
            <KPI label="Delinquency Rate (90+)" value="—" sub="Serious delinquency rate" iconName="warning" color="#ff082f" />
            <KPI label="Default / Foreclosure Rate" value="—" sub="Loans in default or foreclosure" iconName="warning" color="#ff082f" />
            <KPI label="Roll Rates" value="—" sub="Current to 30 to 60 to 90" iconName="chart" color="#f59e0b" />
          </div>
        </div>

        {/* ── Prepayment & Performance ── */}
        <div style={{ background: '#edf1fb', border: '1px solid #c5d3f5', borderRadius: '16px', padding: '20px', marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', fontWeight: '700', color: '#3a6ad9', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>Prepayment & Performance</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
            <KPI label="CPR / SMM" value="—" sub="Conditional prepayment rate" iconName="chart" color="#3a6ad9" />
            <KPI label="Current WA LTV" value="—" sub="Weighted avg loan-to-value" iconName="chart" color="#3a6ad9" />
            <KPI label="WA Loan Age (WALA)" value="—" sub="Weighted avg loan age in months" iconName="clock" color="#3a6ad9" />
            <KPI label="Rate Incentive" value="—" sub="WA coupon vs current market" iconName="chart" color="#acf44e" />
            <KPI label="Cumulative Loss Rate" value="—" sub="Total losses / original balance" iconName="chart" color="#ff082f" />
          </div>
        </div>

        {/* Coverage block removed — non-QM loans can't bind MI. */}

        <div style={{ padding: '24px', background: '#f9fafb', borderRadius: '12px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
          <p style={{ margin: '0 0 4px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>Loan performance data will populate as loans close and enter servicing</p>
          <p style={{ margin: 0, fontSize: '13px', color: '#9ca3af' }}>These metrics are calculated from payment history, loan aging, and portfolio composition data.</p>
        </div>
      </div>
    </AdminLayout>
  );
}
